// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../sellsuki_version.js'
import Vue from 'vue'
import App from './App'
import store from './store'
import filter from '@/utils/filter'
import router from './router'
import Buefy from 'buefy'
import './assets/main.css'
import 'buefy/lib/buefy.css'
import 'begeta/css/begeta.min.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueSellsukiAuth from 'vue-oms-auth'
import SvgFiller from 'vue-svg-filler'
import 'vue-tel-input/dist/vue-tel-input.css'
// import VueTelInput from 'vue-tel-input'

Vue.use(Buefy)

Vue.component('svg-filler', SvgFiller)
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)
Vue.config.productionTip = false
Vue.use(VueSellsukiAuth, {
  portal: process.env.SELLSUKI_LOGIN_PORTAL,
  router: router
})
// Vue.use(VueTelInput)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  filter,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js